import React, { useLayoutEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Container, Divider, Stack, Typography, Box } from "@mui/material";
import { Card, Space } from "antd";
import { Droppable } from "react-beautiful-dnd";
import {
  AppointmentType,
  ColumnType,
} from "../Appointments/AppointmentsKanban/appointmentsConstants";
import { Task } from "./Task";
import { IAppointmentsDataType } from "../../redux/reduxAppointments/appointmentsSlice";
import "./kanban.css";

export function Column({
  column,
  appointments,
}: {
  column: ColumnType;
  appointments: IAppointmentsDataType[];
}) {
  return (
    <Droppable droppableId={column.id}>
      {(provided, snapshot) => (
        <Box
          maxWidth="sm"
          style={{
            margin: "2rem",
            border: "1px solid lightgrey",
            borderRadius: "4px",
            // flex: "1",
            // float: "left",
            // display: "inline-block",
            paddingTop: "1rem",
            width: "20rem",
            height: "75rem",
            textAlign: "center",
            transition: "background-color 0.5s ease",
          }}
          ref={provided.innerRef}
          {...provided.droppableProps}
          data-isdragging-over={snapshot.isDraggingOver}
        >
          <div className="isolate  bg-white/20 ring-1 ring-black/5 backdrop-blur-xl">
            <Typography variant="h4" gutterBottom>
              {column.title}
              <Divider />
            </Typography>
          </div>

          {/* <Stack
            spacing={1}
            ref={provided.innerRef}
            {...provided.droppableProps}
          > */}
          {appointments.map((appointment, index) => (
            <Task
              key={appointment.id}
              appointment={appointment}
              index={index}
            />
          ))}
          {provided.placeholder}
          {/* </Stack> */}
        </Box>
      )}
    </Droppable>
  );
}
